/** Non-table fixtures — top-down room markers (distinct colors per kind). */
export const FLOOR_OBJECT_PRESETS = [
    {
        kind: 'door',
        label: 'Door',
        tip: 'Entrance / exit',
        icon: 'exit-outline',
        width: 88,
        height: 56,
        color: '#B45309',
    },
    {
        kind: 'kitchen',
        label: 'Kitchen',
        tip: 'Prep / open kitchen',
        icon: 'restaurant-outline',
        width: 180,
        height: 120,
        color: '#78716C',
    },
    {
        kind: 'bar',
        label: 'Bar',
        tip: 'Service bar counter',
        icon: 'wine-outline',
        width: 200,
        height: 72,
        color: '#92400E',
    },
    {
        kind: 'pos',
        label: 'POS',
        tip: 'Register station',
        icon: 'card-outline',
        width: 96,
        height: 78,
        color: '#475569',
    },
    {
        kind: 'restroom',
        label: 'Restroom',
        tip: 'Washrooms',
        icon: 'man-outline',
        width: 100,
        height: 90,
        color: '#0284C7',
    },
    {
        kind: 'wall',
        label: 'Wall',
        tip: 'Divider / partition',
        icon: 'remove-outline',
        width: 180,
        height: 22,
        color: '#1C1917',
    },
    {
        kind: 'plant',
        label: 'Plant',
        tip: 'Decor marker',
        icon: 'leaf-outline',
        width: 52,
        height: 52,
        color: '#16A34A',
    },
    {
        kind: 'stairs',
        label: 'Stairs',
        tip: 'Stairs / level change',
        icon: 'trail-sign-outline',
        width: 90,
        height: 110,
        color: '#57534E',
    },
];
export const createFloorObject = (preset, x, y, zIndex) => ({
    id: `obj_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`,
    kind: preset.kind,
    label: preset.label,
    x,
    y,
    width: preset.width,
    height: preset.height,
    rotation: 0,
    zIndex,
});
export const getObjectPreset = (kind) => FLOOR_OBJECT_PRESETS.find(item => item.kind === kind) ||
    FLOOR_OBJECT_PRESETS[0];
